import React, { useState } from 'react';

import { ButtonBase, Grid2 } from '@mui/material';
import { useTranslation } from 'react-i18next';

import ErrorMessage from 'libs/react-hook-form/ErrorMessage';
import { S3SignedUploadUrl } from 'services/api/ailyssaApi';
import { FieldValues, useController, useWatch } from 'react-hook-form';
import { FileUploadFieldRendererProps } from '../FieldRenderers';
import S3FileField from './S3FileField';
import CustomDialog from '../../CustomDialog';

const S3ImageField = <T extends FieldValues>({
  defaultImage,
  uploadedImageUrlName,
  ...props
}: FileUploadFieldRendererProps<T>) => {
  let uploadedImageUrl = '';

  if (uploadedImageUrlName) {
    // The order of the hooks called on re-render will still remain the same
    uploadedImageUrl = useWatch({
      control: props.control,
      name: uploadedImageUrlName ?? '',
    }) as unknown as string;
  }

  const { t } = useTranslation('common');
  const {
    formState: { errors },
    field,
  } = useController({ control: props.control, name: props.name });

  const [imageUrl, setImageUrl] = useState<string>(defaultImage || '');

  return (
    <Grid2 container spacing={1} sx={{ alignItems: 'center' }}>
      <Grid2 size="grow">
        <S3FileField
          onChange={(resp: string | S3SignedUploadUrl) => {
            if (typeof resp === 'string') {
              setImageUrl(resp);
              return;
            }

            setImageUrl(resp.download_url);
            field.onChange(resp.key);
          }}
          {...props}
        />
      </Grid2>
      {(imageUrl || uploadedImageUrl) && (
        <Grid2>
          <CustomDialog
            title={t('common.imagePreview', 'Image Preview')}
            noFooter
            triggerButton={
              <ButtonBase>
                <img
                  width={60}
                  height={60}
                  src={imageUrl || uploadedImageUrl}
                  alt={`${props.name}`}
                  style={{ border: '1px solid' }}
                />
              </ButtonBase>
            }
            maxWidth={false}
            dialogContentProps={{
              sx: { display: 'flex', justifyContent: 'center' },
            }}
          >
            <img src={imageUrl || uploadedImageUrl} alt={`${props.name}`} />
          </CustomDialog>
        </Grid2>
      )}
      <Grid2 size={12}>
        <ErrorMessage name={props.name} errors={errors} />
      </Grid2>
    </Grid2>
  );
};

export default S3ImageField;
